import { format, parse } from 'date-fns'
import { urlUtils } from '../utils/url';

const flightOnlyModel = {
  get sessionId() {
    return urlUtils.getSessionIdFromUrl();
  },
  get adults() {
    return urlUtils.getAdultsFromUrl();
  },
  get childrenAges() {
    return urlUtils.getChildrenAgesFromUrl();
  },
  get departureAirportId() {
    return urlUtils.getDepartureIdFromUrl();
  },
  get destinationAirportId() {
    return urlUtils.getDestinationAirportIdFromUrl();
  },
  get departureDate() {
    const departureDate = parse(urlUtils.getDepartureDateFromUrl(), 'yyyyMMdd', new Date());
    if (!(departureDate instanceof Date) || isNaN(departureDate)) {
      return '';
    }
    const formattedDepartureDate = format(departureDate, 'yyyy-MM-dd');
    return formattedDepartureDate;
  },
  get returnDate() {
    const returnDate = parse(urlUtils.getReturnDateFromUrl(), 'yyyyMMdd', new Date());
    if (!(returnDate instanceof Date) || isNaN(returnDate)) {
      return '';
    }
    const formattedReturnDate = format(returnDate, 'yyyy-MM-dd');
    return formattedReturnDate;
  },
  get cabinClass() {
    return urlUtils.getCabinClassFromUrl();
  },
};

export default flightOnlyModel;
